export default __webpack_public_path__ + "static/media/sortIcon.c3d465fa.svg";